module.exports = __webpack_public_path__ + "img/c2.26682694.png";